import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import CartaPorteAutotransporteRemolquesForm from './CartaPorteAutotransporteRemolquesForm';
import CartaPorteAutotransporteRemolquesList from './CartaPorteAutotransporteRemolquesList';

class CartaPorteAutotransporteRemolquesManager extends Component {
  state = {}

  handleOnAdd = (data) => {
    const { Remolques = {} } = this.props.data;
    const { Remolque = [] } = Remolques;

    const newData = Remolque.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    this.props.onChange({
      ...this.props.data,
      Remolques: {
        Remolque: data
      }
    });
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { Remolques = {} } = this.props.data;
    const { Remolque = [] } = Remolques;

    return (
      <>
        <fieldset>
          <legend>Remolques</legend>

          <CartaPorteAutotransporteRemolquesForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <CartaPorteAutotransporteRemolquesList
            data={ Remolque }
          onEdit={ this.handleOnEdit }
          onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default CartaPorteAutotransporteRemolquesManager;